import { render, staticRenderFns } from "./orderStatusList.vue?vue&type=template&id=331548f4&scoped=true&"
import script from "./orderStatusList.vue?vue&type=script&lang=js&"
export * from "./orderStatusList.vue?vue&type=script&lang=js&"
import style0 from "./orderStatusList.vue?vue&type=style&index=0&id=331548f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331548f4",
  null
  
)

export default component.exports